import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Star, MapPin } from "lucide-react";

const REVIEWS = [
  {
    name: "Tejas",
    tag: "First visit · Style-U Tambe Nagar",
    text:
      "First time at Style-U and I'm genuinely impressed. No rush, proper consultation, and a haircut that actually suits my face shape. The staff was patient with all my questions. Already booked my next one.",
  },
  {
    name: "Rahul",
    tag: "Regular · Style-U Tambe Nagar",
    text:
      "My weekly appointment for the last three years. The team remembers my preferences down to the way I like my sideburns. Hard to find this kind of consistency anywhere else in Mulund.",
  },
  {
    name: "Deepak",
    tag: "Regular · 7 Hills · Beard makeover",
    text:
      "I only trust 7 Hills with my beard. Every few weeks Suresh sir and his team re-shape and line it up sharp. I walk in scruffy, I walk out sharp — every single time. Nobody does the beard detailing like they do.",
  },
  {
    name: "Aryan",
    tag: "Regular · Style-U Veena Nagar",
    text:
      "Been coming to Style-U Veena Nagar for years. Suresh sir knows exactly how I like my fade without me saying a word. Quick, clean, no nonsense — and the head massage after the wash is the best part of my week.",
  },
];

const BRANCHES = [
  {
    name: "Tambe Nagar Branch",
    sub: "Style-U · Mulund West",
    phone: "+91 72084 50811",
    tel: "+917208450811",
    image:
      "https://customer-assets.emergentagent.com/job_salon-simple-1/artifacts/qfxweid8_WhatsApp%20Image%202026-04-19%20at%208.46.18%20PM.jpeg",
    fit: "cover",
  },
  {
    name: "7 Hills Salon",
    sub: "Goregaon West · Near Vivek College",
    phone: "+91 77384 70671",
    tel: "+917738470671",
    image:
      "https://customer-assets.emergentagent.com/job_salon-simple-1/artifacts/8xl8ye6y_WhatsApp%20Image%202026-04-20%20at%207.21.08%20PM.jpeg",
    fit: "cover",
  },
  {
    name: "Veena Nagar Branch",
    sub: "Style-U · Mulund West",
    phone: "+91 75068 30887",
    tel: "+917506830887",
    image:
      "https://customer-assets.emergentagent.com/job_salon-simple-1/artifacts/n5vjk7bt_WhatsApp%20Image%202026-04-19%20at%208.46.38%20PM.jpeg",
    fit: "contain",
  },
];

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-black text-white">
      {/* HERO */}
      <section
        data-testid="home-hero"
        className="relative min-h-[100vh] w-full overflow-hidden bg-black"
      >
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 pt-44 pb-24 min-h-[100vh] flex flex-col justify-between">
          <div className="max-w-3xl">
            <p
              className="label-eyebrow na-fade-up"
              data-testid="home-hero-eyebrow"
            >
              Style-U × 7 Hills · Unisex Salon
            </p>
            <p
              data-testid="home-hero-tagline"
              className="mt-4 text-white text-sm sm:text-base md:text-lg tracking-[0.15em] uppercase font-semibold na-fade-up na-delay-1"
            >
              Best in service in <span className="text-[#ffd36e]">Mulund</span> &amp; <span className="text-[#ffd36e]">Goregaon West</span> — <span className="italic font-serif-display text-white/90 normal-case tracking-normal text-base sm:text-lg md:text-xl">since a decade.</span>
            </p>
            <h1
              data-testid="home-hero-title"
              className="font-serif-display text-5xl sm:text-6xl lg:text-[7.5rem] leading-[0.95] tracking-tighter mt-8 na-fade-up na-delay-1"
            >
              Premium grooming,
              <br />
              <span className="italic text-[#cfa86e]">quietly crafted.</span>
            </h1>
            <p
              data-testid="home-hero-sub"
              className="mt-10 max-w-xl text-base md:text-lg text-white/70 leading-relaxed na-fade-up na-delay-2"
            >
              Three salons, one vision — led by Mr. Suresh Bhandari. Style-U
              Veena Nagar, Style-U Tambe Nagar, and 7 Hills Salon in Goregaon
              West bring together classic barbering, modern styling and skin
              care under a single standard of care.
            </p>

            <div className="mt-12 flex flex-col sm:flex-row gap-6 sm:gap-10 items-start sm:items-center na-fade-up na-delay-3">
              <Link
                to="/services"
                data-testid="home-hero-cta-services"
                className="group inline-flex items-center gap-3 border border-white/20 hover:border-[#cfa86e] px-8 py-4 text-sm tracking-[0.25em] uppercase transition-colors duration-500"
              >
                <span className="text-white group-hover:text-[#cfa86e] transition-colors duration-500">
                  Explore Services
                </span>
                <ArrowUpRight
                  size={16}
                  strokeWidth={1.25}
                  className="text-[#cfa86e] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500"
                />
              </Link>
              <Link
                to="/owner"
                data-testid="home-hero-cta-owner"
                className="na-link text-sm tracking-[0.25em] uppercase text-white/80"
              >
                Meet the Founder
              </Link>
              <a
                href="tel:+919820981555"
                data-testid="home-hero-proprietor-phone"
                className="group inline-flex items-center gap-2 text-sm tracking-[0.15em] text-white/90 hover:text-[#ffd36e] transition-colors border-b border-dashed border-white/30 hover:border-[#ffd36e] pb-1"
              >
                <Phone size={15} strokeWidth={1.4} className="text-[#ffd36e]" />
                <span>Call Suresh · +91 98209 81555</span>
              </a>
            </div>
          </div>

          <div className="hidden md:flex items-end justify-between mt-20">
            <div className="max-w-xs">
              <span className="label-eyebrow">Hours</span>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                Open Tue — Sun, 8:00 AM to 9:30 PM
                <br />
                <span className="text-[#ffd36e]">Closed on Mondays.</span>
              </p>
            </div>
            <div className="max-w-xs text-right">
              <span className="label-eyebrow">Three Locations</span>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">
                Style-U Veena Nagar · Style-U Tambe Nagar · 7 Hills Salon, Goregaon West — led by Mr. Suresh Bhandari.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* STATS STRIP */}
      <section
        data-testid="home-stats"
        className="border-t border-white/10 py-16 md:py-20 px-6 lg:px-12"
      >
        <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          {[
            {
              k: "home-stat-rating",
              value: "4.3",
              label: "Average Rating",
              sub: (
                <span className="inline-flex items-center gap-0.5 text-[#ffd36e]">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={11} strokeWidth={1.5} fill={s < 4 ? "currentColor" : "none"} />
                  ))}
                </span>
              ),
            },
            {
              k: "home-stat-customers",
              value: "2,500+",
              label: "Customers Served",
              sub: <span className="text-white/50">Across three salons</span>,
            },
            {
              k: "home-stat-experience",
              value: "32+",
              label: "Years of Experience",
              sub: <span className="text-white/50">By Mr. Suresh Bhandari</span>,
            },
            {
              k: "home-stat-location",
              value: "Mumbai",
              label: "Proudly Based In",
              sub: (
                <span className="inline-flex items-center gap-1.5 text-white/50">
                  <MapPin size={11} strokeWidth={1.5} className="text-[#ffd36e]" />
                  Mulund · Goregaon West
                </span>
              ),
            },
          ].map((s) => (
            <div
              key={s.k}
              data-testid={s.k}
              className="flex flex-col md:items-start"
            >
              <span className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-white leading-none tracking-tight">
                {s.value}
              </span>
              <span className="label-eyebrow mt-4">{s.label}</span>
              <span className="mt-2 text-xs text-white/55 tracking-wide">
                {s.sub}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURE STRIP */}
      <section
        data-testid="home-features"
        className="border-t border-white/10 py-24 px-6 lg:px-12"
      >
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8">
          {[
            {
              k: "01",
              t: "Three Salons",
              d: "Style-U Veena Nagar, Style-U Tambe Nagar & 7 Hills Goregaon West — held to a single standard of care.",
            },
            {
              k: "02",
              t: "Master's Eye",
              d: "Every chair watched over by Mr. Suresh Bhandari — decades at the blade.",
            },
            {
              k: "03",
              t: "Unisex, Always",
              d: "Men, women, children. One room, one welcome, one quality of work.",
            },
          ].map((f) => (
            <div key={f.k} className="md:pr-10">
              <span className="font-serif-display italic text-[#cfa86e] text-3xl">
                {f.k}
              </span>
              <h3 className="font-serif-display text-2xl md:text-3xl mt-4">
                {f.t}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed mt-4 max-w-xs">
                {f.d}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CLIENT REVIEWS — rolling marquee */}
      <section
        data-testid="home-reviews"
        className="border-t border-white/10 py-24 md:py-28 overflow-hidden"
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="label-eyebrow">Clientele</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-6 tracking-tight leading-[1.05]">
              In their <span className="italic text-[#cfa86e]">own words</span>.
            </h2>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed">
            A small sample from the chairs — regulars, newcomers, and a few who've been trusting the same hands for years.
          </p>
        </div>

        <div className="reviews-marquee group">
          <div className="reviews-track">
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <article
                key={`${r.name}-${i}`}
                data-testid={`review-card-${i}`}
                className="shrink-0 w-[88vw] sm:w-[420px] md:w-[460px] border border-white/15 bg-white/[0.03] rounded-sm p-7 md:p-8 mx-3"
              >
                <div className="flex items-center gap-1 text-[#ffd36e]">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={14} strokeWidth={1.5} fill="currentColor" />
                  ))}
                </div>
                <p className="mt-5 text-white/85 text-[15px] md:text-base leading-relaxed">
                  "{r.text}"
                </p>
                <div className="mt-7 flex items-center gap-4">
                  <div className="h-11 w-11 shrink-0 rounded-full bg-[#ffd36e]/15 border border-[#ffd36e]/40 flex items-center justify-center font-serif-display text-[#ffd36e] text-lg">
                    {r.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-serif-display text-xl text-white leading-tight">
                      {r.name}
                    </p>
                    <p className="text-white/55 text-xs tracking-wide mt-1">
                      {r.tag}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT — visible on front page */}
      <section
        data-testid="home-contact"
        className="border-t border-white/10 py-28 md:py-32 px-6 lg:px-12"
      >
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-end">
            <div className="md:col-span-6">
              <p className="label-eyebrow">Call Us</p>
              <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-6 tracking-tight leading-[1.05]">
                Three chairs, <span className="italic text-[#cfa86e]">one phone call</span> away.
              </h2>
            </div>
            <div className="md:col-span-6 md:text-right">
              <p className="label-eyebrow mb-3">Proprietor</p>
              <a
                href="tel:+919820981555"
                data-testid="home-proprietor-phone"
                className="group inline-flex items-center gap-3 font-serif-display text-2xl md:text-3xl text-white hover:text-[#ffd36e] transition-colors"
              >
                <Phone size={20} strokeWidth={1.3} className="text-[#ffd36e]" />
                Mr. Suresh Bhandari · +91 98209 81555
              </a>
            </div>
          </div>

          {/* Booking notice */}
          <div
            data-testid="home-booking-notice"
            className="mt-12 border border-[#ffd36e]/50 bg-[#ffd36e]/10 px-6 py-5 md:px-8 md:py-6 rounded-sm"
          >
            <p className="font-bold text-white text-base md:text-lg tracking-wide leading-snug">
              Bookings are accepted <span className="text-[#ffd36e]">only through phone calls</span> to the respective branches.
              <br className="hidden sm:block" />
              <span className="text-white">No online booking accepted.</span>
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {BRANCHES.map((b, i) => (
              <a
                key={b.name}
                href={`tel:${b.tel}`}
                data-testid={`home-branch-phone-${i}`}
                className="group block"
              >
                {/* Framed portrait photo */}
                <div className="relative rounded-[28px] overflow-hidden border border-white/20 group-hover:border-[#ffd36e] transition-colors duration-500 aspect-[3/4.2] bg-black">
                  <img
                    src={b.image}
                    alt={b.name}
                    loading="lazy"
                    className={`absolute inset-0 w-full h-full ${
                      b.fit === "contain" ? "object-contain" : "object-cover"
                    } transition-transform duration-700 group-hover:scale-105`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none" />
                  <span className="absolute top-5 right-5 font-serif-display italic text-[#ffd36e]/90 text-sm tracking-wider">
                    0{i + 1}
                  </span>
                </div>

                {/* Label under photo */}
                <div className="mt-5 text-center">
                  <p className="text-white text-sm sm:text-base tracking-[0.28em] uppercase font-semibold">
                    {b.name}
                  </p>
                  <p className="text-white/55 text-xs mt-2 tracking-wide">
                    {b.sub}
                  </p>
                  <div className="mt-3 inline-flex items-center gap-2 text-[#ffd36e] group-hover:text-white transition-colors">
                    <Phone size={14} strokeWidth={1.5} />
                    <span className="tracking-wide text-sm sm:text-base">
                      {b.phone}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA — pull into Services */}
      <section
        data-testid="home-cta-strip"
        className="border-t border-white/10 py-32 px-6 lg:px-12"
      >
        <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-start md:items-end gap-12">
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl max-w-2xl tracking-tight leading-[1.05]">
            Our craft, <span className="italic text-[#cfa86e]">in full</span>.
          </h2>
          <Link
            to="/services"
            data-testid="home-cta-services-inline"
            className="group inline-flex items-center gap-3 text-sm tracking-[0.25em] uppercase border-b border-white/30 hover:border-[#cfa86e] pb-2 transition-colors"
          >
            <span className="text-white group-hover:text-[#cfa86e] transition-colors">
              View all services
            </span>
            <ArrowUpRight size={16} strokeWidth={1.25} className="text-[#cfa86e]" />
          </Link>
        </div>
      </section>
    </div>
  );
}
